"use client";

import { Phone, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function QuickReservationCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="quick-reservation-calltoaction" ref={ref} className="relative min-h-[80vh] flex items-center justify-center overflow-hidden py-20">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/los_angeles_skyline_dusk.png)]" />
      <div className="surface-overlay bg-primary-dark/60" />

      <div className={`container relative z-10 px-4 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="max-w-4xl mx-auto">
          <div className="glass-effect p-8 md:p-12 text-center border-white/10">
            <div className="inline-flex items-center justify-center gap-2 mb-6 px-4 py-1.5 rounded-lg bg-secondary/20 border border-secondary/30">
              <span className="relative flex size-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-secondary opacity-75" />
                <span className="relative inline-flex rounded-lg size-2 bg-secondary" />
              </span>
              <span className="text-xs md:text-sm font-semibold text-secondary uppercase tracking-[0.2em]">
                Immediate Dispatch Available
              </span>
            </div>

            <h2 className="text-white text-xl md:text-2xl font-sans font-light tracking-widest uppercase mb-4">
              Premium Chauffeur Service
            </h2>
            
            <Link to="tel:323-492-6292" className="group block mb-10 focus-ring rounded-lg">
              <div className="flex flex-col md:flex-row items-center justify-center gap-4 transition-transform duration-[var(--duration-medium)] hover:scale-[1.02]">
                <Phone className="size-10 md:size-14 text-secondary" />
                <span className="text-5xl md:text-7xl lg:text-8xl font-display font-bold text-white tracking-tighter">
                  323-492-6292
                </span>
              </div>
            </Link>

            <div className="grid md:grid-cols-2 gap-8 items-center mb-10">
              <div className="relative group overflow-hidden rounded-lg shadow-strong">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/luxury_sedan_interior.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/luxury_sedan_interior.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/luxury_sedan_interior.png-wvc-sizes" alt="Luxury Sedan Interior" className="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              </div>
              
              <div className="text-left space-y-6">
                <p className="text-white/80 text-lg leading-relaxed font-sans">
                  Experience the pinnacle of Los Angeles transportation. Our professional chauffeurs are standing by to provide seamless airport transfers, VIP event bookings, and hourly service.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-4">
                  <Button asChild className="btn-primary w-full sm:w-auto text-base py-7 px-10">
                    <Link to="tel:323-492-6292">
                      Call or Text Now
                    </Link>
                  </Button>
                  
                  <div className="flex items-center gap-3 px-4 py-2 rounded-md bg-white/5 border border-white/10">
                    <Clock className="size-5 text-secondary" />
                    <span className="text-white/90 text-sm font-medium uppercase tracking-wider">
                      24/7 Support
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="pt-8 border-t border-white/10">
              <p className="text-white/40 text-xs uppercase tracking-[0.3em]">
                Phoenix Enterprise TCP &bull; Los Angeles &bull; Beverly Hills &bull; Santa Monica
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}